import { Injectable } from '@angular/core';
import { Product, TranslationService, WindowRef } from '@spartacus/core';
import { firstValueFrom } from 'rxjs';
import { CollapseItem } from '../../../../../components/collapse-list/model/collapse.model';
import { ProductInventoryComponent } from '../../product-inventory/product-inventory.component';
import { Warehouse } from '../../product-inventory/core/product-inventory.model';
import { ProductCheckInventoryService } from '../../product-inventory/product-check-inventory.service';

@Injectable({
  providedIn: 'root',
})
export class ProductListItemService {
  constructor(
    private winref: WindowRef,
    private translationService: TranslationService,
    private productCheckInventoryService: ProductCheckInventoryService,
  ) {}

  async populateFeatures(product: Product): Promise<CollapseItem[]> {
    const $lis: HTMLLIElement[] = [];
    let keyFeatures: CollapseItem[] = [];

    if (!this.winref.isBrowser()) {
      return [];
    }

    if (product.keySpecs?.length) {
      product.keySpecs?.forEach(spec => {
        const $li = this.winref.document.createElement(`li`);
        $li.innerText = spec;

        $lis.push($li);
      });
    } else {
      const $li = this.winref.document.createElement(`li`);

      const data = await firstValueFrom(this.translationService.translate('keyFeatures.noContent'));
      $li.innerText = data;

      $lis.push($li);
    }

    const $lisHtml = $lis.map(li => li.outerHTML).join('');

    const keyFeaturesTitle = await firstValueFrom(this.translationService.translate('keyFeatures.keyFeatures'));
    keyFeatures = [
      {
        id: 'key-feature',
        title: keyFeaturesTitle,
        content: `
                        <ul class="p-tb-0 m-0 p-rl-40">
                            ${$lisHtml}
                        </ul>
                    `,
        isOpen: false,
      },
    ];

    if (!product.discontinued) {
      const checkInventoryTitle = await firstValueFrom(this.translationService.translate('keyFeatures.checkInventory'));
      keyFeatures.push({
        id: 'check-inventory',
        title: checkInventoryTitle,
        component: ProductInventoryComponent,
        data: {
          product: product,
          hasRadioOptions: true,
          onChangeWarehouse: (warehouse: Warehouse) => {
            this.productCheckInventoryService.setWarehouseProduct({
              productID: product.code!,
              warehouseID: warehouse.warehouseCode!,
            });
          },
        },
        isOpen: false,
      });
    }

    return keyFeatures;
  }
}